import {useContext} from "react";
import QRCodeContext from "../../../../contexts/qr-code/QRCodeContext";
import SimpleQRCode from "../../../../api/qr-code/SimpleQRCode";
import QRCodeViewItem from "./item/QRCodeViewItem";
import classNames from "./QRCodeListView.module.css";
import {Group, Pagination, Transition} from "@mantine/core";

/**
 * @author Kacper Faber
 * @since 0.1.7
 * @constructor
 */
function QRCodeListView() {
    /**
     * QR code context
     * @author Kacper Faber
     * @since 0.1.7
     */
    const qrCodeContext = useContext(QRCodeContext);

    /**
     * Render item
     * @since 0.1.7
     * @author Kacper Faber
     * @param qrCode
     */
    const renderItem = (qrCode: SimpleQRCode) => {
        return (
            <QRCodeViewItem
                qrCode={qrCode}
            />
        );
    }

    const onPageChange = (page: number) => {
        qrCodeContext.setQuery({ ...qrCodeContext.query, page });
    }

    /**
     * Render items.
     * @author Kacper Faber
     * @since 0.1.7
     */
    const renderItems = () => {
        return qrCodeContext?.page?.results?.map(renderItem);
    }

    return (
        <Transition mounted={!qrCodeContext.isFetching}>
            {styles =>
                <>
                    <div style={styles} className={classNames.list}>
                        {renderItems()}
                    </div>

                    <Group justify="center" mt="xl">
                        <Pagination
                            total={qrCodeContext.page?.totalPages ?? 0}
                            value={qrCodeContext.page?.pageNumber}
                            onChange={onPageChange}
                        />
                    </Group>
                </>
            }
        </Transition>
    );
}

export default QRCodeListView;